// Shared Contentful fixtures. Consumed twice: by the dev-mock service swap
// (via @maia/core, Angular runtime) and by the e2e route stubs (via the
// @maia/mocks/contentful narrow alias, plain Playwright context). Plain data
// only - no Angular imports - so the e2e alias stays safe to import outside an
// Angular context. Document ids mirror the referencedDocs in mock-responses.

export interface MockContentfulDocument {
  title: string;
  createdAt: string;
  body: string;
}

export const MOCK_CONTENTFUL_TOKEN: Readonly<string> = 'mock-contentful-token';

export const MOCK_CONTENTFUL_DOCUMENTS: Readonly<Record<string, MockContentfulDocument>> = {
  '5mPDbJzjqekJlvU2mS7ZkI': {
    title: 'Temperatuur en Ventilatie',
    createdAt: '2026-03-05T10:51:19+00:00',
    body: '## Temperatuur en Ventilatie\n\nDeze richtlijn beschrijft hoe we temperatuur en ventilatie monitoren op onze locaties.\n\n- Streeftemperatuur binnen: 18 tot 22 graden.\n- Bij overschrijding: schakel over op het hitteprotocol.\n- Ventilatie minimaal 30 minuten per dag, bij voorkeur in de ochtend.',
  },
  '3M06fllfJKpkbXWXw4wzQQ': {
    title: 'Hitteprotocol',
    createdAt: '2026-03-05T15:33:21+00:00',
    body: '## Hitteprotocol\n\nHet hitteprotocol treedt in werking bij 25 graden Celsius of hoger.\n\n- Pas activiteiten aan: minder buitenspel tussen 12 en 15 uur.\n- Zorg voor extra drinkmomenten.\n- Communiceer naar ouders via de gebruikelijke kanalen.',
  },
};

export const MOCK_CONTENTFUL_FALLBACK: Readonly<MockContentfulDocument> = {
  title: 'Bron',
  createdAt: '2026-03-05T00:00:00+00:00',
  body: '## Voorbeeldbron\n\nVoorbeeldinhoud voor de demonstratie.',
};
